import { UseQueryResult, useQuery } from 'react-query';
import { filter, map } from 'lodash';

import { GetInstancesWithGateways } from '@pimm/services/lib/store-equipment/services';
import { EquipmentInstancesDto, GatewayInstanceDto } from '@pimm/services/lib/store-equipment';

export interface DisplayGroup {
  displayGroup: string;
  equipment: EquipmentInstancesDto[];
}

export interface GetDisplayGroupsReturn extends Array<DisplayGroup> {
  gateways: GatewayInstanceDto[];
}

export const useGetDisplayGroups = (siteId?: string, queryKey?: string): UseQueryResult<GetDisplayGroupsReturn> => {
  const displayGroups = useQuery({
    enabled: !!siteId,
    queryKey: [queryKey ?? 'GetInstancesWithGateways', siteId],
    queryFn: async () => {
      const { Equipment, Gateways } = await GetInstancesWithGateways({ SiteId: siteId! }, { timeout: 1.5 * 60 * 1000 });
      const displayGroups = map(['walk', 'cooler', 'freezer', 'other'], key =>
        filter<EquipmentInstancesDto>(Equipment ?? [], instance => {
          return (
            !!instance.TemperatureMetrics?.Temperature &&
            (instance.TemperatureMetrics?.Temperature?.ThresholdProfile?.DisplayGroup?.toLowerCase() || 'other').includes(key)
          );
        }),
      )
        .filter(items => items.length)
        .map(items => ({
          displayGroup: items[0]?.TemperatureMetrics?.Temperature?.ThresholdProfile?.DisplayGroup ?? 'Other',
          equipment: items,
        }));

      return Object.assign(displayGroups, { gateways: Gateways ?? [] });
    },
    refetchInterval: () => {
      const timeNow = new Date();
      // Refetch the timerData every 5 minutes
      const nearestMinutes = timeNow.toNearestNextMinutes(5);
      return nearestMinutes.getTime() - timeNow.getTime();
    },
    refetchOnReconnect: true,
    retry: 2,
  });

  return displayGroups;
};
